const zh = {
  "site.name": "火影漫画",
  "site.subtitle": "官方正版全集在线阅读",
  "nav.home": "首页",
  "nav.category": "分类阅读",
  "nav.about": "关于我们",
  "home.hero.title": "火影漫画官方正版全集",
  "home.hero.subtitle": "收录鸣人从忍者学校到火影之路的全部章节，高清正版免费在线阅读，回顾经典战役与感人剧情",
  "home.hero.cta": "开始阅读",
  "home.hero.about": "了解更多",
  "home.categories.title": "按篇章分类阅读",
  "home.categories.subtitle": "从忍者学校到终结谷，完整收录火影漫画全部章节，按照篇章分类，方便你按顺序阅读",
  "home.hot.title": "热门章节推荐",
  "home.hot.subtitle": "众多火影迷最爱的经典章节，每一话都是不可错过的精彩内容",
  "home.classic.title": "经典战役回顾",
  "home.classic.subtitle": "重温火影漫画中那些让人热血沸腾的经典战斗场景",
  "home.faq.title": "常见问题",
  "home.faq.subtitle": "关于火影漫画阅读的常见问题解答",
  "home.cta.title": "开启你的火影之旅",
  "home.cta.subtitle": "从第一话开始，重新感受这部陪伴了我们青春的伟大作品",
  "home.cta.button": "立即开始阅读",
  "category.title": "分类阅读",
  "category.all": "全部章节",
  "category.chapters": "篇",
  "category.readNow": "立即阅读",
  "category.noChapters": "暂无该分类的章节",
  "article.backToList": "返回列表",
  "article.prevChapter": "上一话",
  "article.nextChapter": "下一话",
  "article.relatedChapters": "相关推荐",
  "article.views": "次阅读",
  "about.title": "关于我们",
  "about.brand.title": "品牌故事",
  "about.brand.content": "火影漫画在线是专为华语地区火影迷打造的正版漫画阅读平台。我们深知火影忍者在每位漫迷心中的特殊地位——它不仅是一部漫画，更是一代人青春的记忆与热血的象征。我们致力于提供最高清、最完整的火影漫画正版内容，让每一位火影迷都能以最好的体验重温这部不朽经典。",
  "about.reputation.title": "用户口碑",
  "about.contact.title": "联系我们",
  "about.contact.subtitle": "有任何问题或建议，欢迎随时联系我们",
  "about.contact.name": "姓名",
  "about.contact.email": "邮箱",
  "about.contact.message": "留言内容",
  "about.contact.submit": "提交留言",
  "about.contact.success": "感谢您的留言，我们会尽快回复！",
  "about.contact.error": "提交失败，请稍后重试",
  "footer.copyright": "版权所有",
  "footer.rights": "保留所有权利",
  "footer.disclaimer": "本站内容仅供学习交流使用",
  "breadcrumb.home": "首页",
  "readCount": "次阅读",
  "chapterCount": "话",
};

export default zh;